import React, { Component } from 'react';
import Splash from './imports/Splash.jsx';

class App extends Component {
  render() {
    return <Splash />;
  }
}

export default App;
